import { Component, Input } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { ActivityRegistryDto } from '../activity-registry-service/activity-registry-dto';
import { ActivityRegistryService } from '../activity-registry-service/activity-registry.service';

@Component({
  selector: 'lp2-activity-registry',
  templateUrl: './activity-registry.component.html',
  styleUrls: ['./activity-registry.component.scss'],
})
export class ActivityRegistryComponent {
  @Input()
  gamificationEnabled = false;

  isLoading = true;
  activityRegistryData: ActivityRegistryDto;
  liveClassEnabled: boolean;

  constructor(
    activityRegistryService: ActivityRegistryService,
    private readonly oeAppPerson: OeAppPersonService
  ) {
    this.isLoading = true;
    activityRegistryService.getActivityRegistryData().subscribe((response) => {
      this.activityRegistryData = response;
      this.isLoading = false;
    });
    this.liveClassEnabled = this.oeAppPerson.liveClassEnabled;
  }
}



// WEBPACK FOOTER //
// ./ts/app/activity-registry/activity-registry/activity-registry.component.ts